import { Stack, Text, Toggle } from "@fluentui/react";
import { PriceListType } from "../../../../Model/CommonModel";
import { BreakpointType } from "../../../Common/Container/ContainerFluid";
import { useBreakpoint } from "../../../Common/Container/ContainerStyles";
import { RegisterService } from "../../../Common/Register/Service/RegisterService";
import { lgRegisterConfigurationPriceListTitleStyles, mdRegisterConfigurationPriceListTitleStyles, registerConfigurationPriceListContainerStyles, registerConfigurationPriceListTitleStyles, registerConfigurationPriceListToggleStyles, smRegisterConfigurationPriceListTitleStyles, xlRegisterConfigurationPriceListTitleStyles, xxlRegisterConfigurationPriceListTitleStyles } from "../../../Common/Register/Components/Configuration/Styles/RegisterConfigurationStyles";


export interface IPartnerConfigurationPriceListProps {
    priceListType: PriceListType;
    onChange: (priceListType: PriceListType) => void;
}

export const PartnerConfigurationPriceList: React.FC<IPartnerConfigurationPriceListProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);
    
    return (
        <Stack
            horizontal
            horizontalAlign="space-between"
            verticalAlign="center"
            verticalFill
            className={registerConfigurationPriceListContainerStyles}
        >
            <Stack>
                <Text
                    className={
                        isSM ?
                            smRegisterConfigurationPriceListTitleStyles : 
                        isMD ? 
                            mdRegisterConfigurationPriceListTitleStyles :
                        isLG ?
                            lgRegisterConfigurationPriceListTitleStyles :
                        isXL ?
                            xlRegisterConfigurationPriceListTitleStyles :
                        isXXL ?
                            xxlRegisterConfigurationPriceListTitleStyles
                        :
                            registerConfigurationPriceListTitleStyles
                    }
                >    
                    {RegisterService.translate("configuration:yearPriceList")}
                </Text>
            </Stack>
            <Stack
                horizontal
                horizontalAlign="center"
                verticalAlign="end"
                verticalFill
            >
                <Toggle
                    checked={props.priceListType === PriceListType.Yearly}
                    styles={registerConfigurationPriceListToggleStyles}
                    onChange={(ev, checked) => {props.onChange(checked ? PriceListType.Yearly : PriceListType.Monthly)}} 
                />
            </Stack>
        </Stack>
    );
};